export default __webpack_public_path__ + "static/media/poster11.84359c1e.png";